import { appRegistry } from '@commander/utils';
import type { NavigateFunction } from 'react-router-dom';

const APP_ROUTE_PREFIXES = [
  { appId: 'crm', prefix: '/crm' },
  { appId: 'prospecting', prefix: '/prospecting' },
  { appId: 'success', prefix: '/success' },
  { appId: 'routing', prefix: '/routing' },
  { appId: 'driver', prefix: '/driver-routing' },
];

function isLocalhost(location?: { hostname?: string }) {
  const loc = location || (typeof window !== 'undefined' ? window.location : null);
  return Boolean(loc?.hostname === 'localhost' || loc?.hostname === '127.0.0.1');
}

function localSearchRouteUrl(appId: string, normalizedRoute: string) {
  const app = appRegistry.getAppById(appId);
  if (!app) return normalizedRoute;
  return `http://localhost:${app.port}${normalizedRoute}`;
}

export function getSearchPageHref(
  searchParams: URLSearchParams,
  location?: { hostname?: string; port?: string }
): string {
  const path = `/search?${searchParams.toString()}`;
  const effectiveLocation = location || (typeof window !== 'undefined' ? window.location : null);

  if (effectiveLocation && isLocalhost(effectiveLocation) && effectiveLocation.port !== '3000') {
    return `http://${effectiveLocation.hostname}:3000${path}`;
  }

  return path;
}

export function getSearchResultHref(
  route: string,
  location?: { hostname?: string; port?: string }
): string {
  if (/^https?:\/\//i.test(route)) return route;

  const normalizedRoute = route.startsWith('/') ? route : `/${route}`;
  const appRoute = APP_ROUTE_PREFIXES.find(
    ({ prefix }) => normalizedRoute === prefix || normalizedRoute.startsWith(`${prefix}/`)
  );

  if (!appRoute) return normalizedRoute;

  const effectiveLocation = location || (typeof window !== 'undefined' ? window.location : null);
  if (effectiveLocation && isLocalhost(effectiveLocation) && effectiveLocation.port === '5173') {
    return localSearchRouteUrl(appRoute.appId, normalizedRoute);
  }

  const subPath = normalizedRoute.slice(appRoute.prefix.length) || '/';
  return appRegistry.getAppUrl(appRoute.appId, subPath);
}

export function openSearchResult(
  route: string,
  navigate: NavigateFunction,
  locationOverride?: { hostname?: string; port?: string; href?: string }
) {
  const href = getSearchResultHref(route, locationOverride);
  const isCrossApp =
    /^https?:\/\//i.test(href) ||
    (locationOverride?.href ? /^https?:\/\//i.test(locationOverride.href) : href !== route);
  if (isCrossApp) {
    window.location.href = href;
    return;
  }

  navigate(href);
}
